import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import Announcementslider from "./Announcementslider";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../config/api";

function Viewers({ prop }) {
  const location = useLocation();
  const stateValue = location.state && location.state["userPermissions"];
  const [dailyEntryData, setdailyEntryData] = useState([]);
  // console.log("State Value", stateValue);
  const [data, setData] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);
  const [focusedIndex, setFocusedIndex] = useState(0);
  const [isAuth, setIsAuth] = useState(false);
  const [isSuperuser, setIsSuperuser] = useState(false); // State to store superuser status
  const navigate = useNavigate();
  const [latestNews, setLatestNews] = useState(null);
  const [pipelineandturnedup, setPipelineandturnedup] = useState(null);
  const [displayMode, setDisplayMode] = useState('target_candidates'); // 'target_candidates' or 'revenue'
  const handleSignOut = () => {
    // For illustration purposes, let's clear the access token from localStorage
    localStorage.removeItem("access_token");

    // Redirect to the home page
    navigate("/");
  };

  // Fetch display mode settings
  useEffect(() => {
    const fetchDisplayMode = async () => {
      try {
        const accessToken = localStorage.getItem("access_token");
        if (accessToken) {
          const response = await fetch(getApiUrl('/display-mode-settings/'), {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
          const result = await response.json();
          setDisplayMode(result.pace_display_mode || 'target_candidates');
        }
      } catch (error) {
        console.error("Error fetching display mode:", error);
      }
    };
    fetchDisplayMode();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("access_token") !== null) {
      setIsAuth(true); // Set authentication status to true if access token is present
      fetch(getApiUrl(API_ENDPOINTS.GET_ALL_RECORDS), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          setData(data.records || []); // Update state with fetched data
          setdailyEntryData(data.monthly_records || []); // Update state with fetched data

          setIsSuperuser(data.is_superuser);
          setUserPermissions(data.user_permissions || []);
          setLatestNews(data.latest_news);
          setPipelineandturnedup(data.pipelineandturnedup || []);

          if (data.latest_news == "New News Updated") {
            navigate("/celebrationPage");
          }
        })
        .catch((error) => { });
    }
  }, []);

  const sortedData = useMemo(() => {
    if (!dailyEntryData || !pipelineandturnedup || !data) return [];

    return dailyEntryData
      .map((entry) => {
        const pipeline =
          pipelineandturnedup.find((item) => item.user === entry.user)
            ?.pipline || 0;
        const turnedUpRatio =
          entry.turned_up && pipeline
            ? ((entry.selected + entry.turned_up) / entry.resume_forwarded) *
            100
            : 0;
        const correspondingRecord = data.find(
          (record) => record.id === entry.user
        );
        const targetRev = correspondingRecord ? correspondingRecord.revenue : 0;
        const target = correspondingRecord ? correspondingRecord.target : 0;

        return {
          ...entry,
          pipeline,
          turnedUpRatio,
          targetRev,
          target,
        };
      })
      .sort((a, b) => {
        // Sort based on display mode
        const bExp = isNaN(b.expected_revenue) ? 0 : parseFloat(b.expected_revenue);
        const aExp = isNaN(a.expected_revenue) ? 0 : parseFloat(a.expected_revenue);
        const bRev = isNaN(b.revenue) ? 0 : parseFloat(b.revenue);
        const aRev = isNaN(a.revenue) ? 0 : parseFloat(a.revenue);

        if (displayMode === 'revenue') {
          // Sort by expected revenue first when in revenue mode
          if (Math.abs(bExp - aExp) > 0.01) return bExp - aExp;
          if (Math.abs(bRev - aRev) > 0.01) return bRev - aRev;
          if (b.selected !== a.selected) return b.selected - a.selected;
          if (b.resume_forwarded !== a.resume_forwarded)
            return b.resume_forwarded - a.resume_forwarded;
          if (b.turnedUpRatio !== a.turnedUpRatio)
            return b.turnedUpRatio - a.turnedUpRatio;
          return b.pipeline - a.pipeline;
        } else {
          // Sort by target/candidates (selected) first when in target mode
          if (b.selected !== a.selected) return b.selected - a.selected;
          if (Math.abs(bExp - aExp) > 0.01) return bExp - aExp;
          if (Math.abs(bRev - aRev) > 0.01) return bRev - aRev;
          if (b.resume_forwarded !== a.resume_forwarded)
            return b.resume_forwarded - a.resume_forwarded;
          if (b.turnedUpRatio !== a.turnedUpRatio)
            return b.turnedUpRatio - a.turnedUpRatio;
          return b.pipeline - a.pipeline;
        }
      });
  }, [dailyEntryData, pipelineandturnedup, data, displayMode]);

  // ############################ Iteration ########################################
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(5);
  const totalPages = Math.ceil((sortedData && sortedData.length) / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentViewers =
    sortedData && sortedData.slice(indexOfFirstRecord, indexOfLastRecord);
  const globalRecordCount = (currentPage - 1) * recordsPerPage;

  const paginate = () => {
    setCurrentPage((prevPage) => (prevPage === totalPages ? 1 : prevPage + 1));
  };

  useEffect(() => {
    if (data && data.length > 0) {
      const focusOnRecord = (index) => {
        setFocusedIndex(index);

        const timer = setTimeout(() => {
          const nextIndex = index + 1;

          if (nextIndex >= currentViewers.length) {
            if (currentPage < totalPages) {
              paginate();
              setFocusedIndex(0);
            } else {
              if (
                !isSuperuser &&
                !userPermissions.includes("website.see_records") &&
                !userPermissions.includes("website.update_target")
              ) {
                navigate("/slider");
              }
            }
          } else {
            setFocusedIndex(nextIndex); // Focus on the next record
          }
        }, 2000);

        // Cleanup timer
        return () => clearTimeout(timer);
      };

      // Start focusing on the first record when the component mounts or data changes
      focusOnRecord(focusedIndex);

      // Reset focus index when the component unmounts
      return () => setFocusedIndex(0);
    }
  }, [
    focusedIndex,
    data,
    currentViewers,
    currentPage,
    totalPages,
    paginate,
    navigate,
    isSuperuser,
    userPermissions,
  ]);

  // ############################ Iteration ########################################

  return (
    <>
      <section>
        <div>
          <div>
            <div>
              <div>
                {/****************************** Viewer Code (Someone) ******************************/}
                <table
                  class="myTable min-w-full bg-white"
                  style={{ width: "95%", margin: "auto" }}
                >
                  <thead>
                    <tr>
                      {/* <th scope="col">Rank</th>  */}
                      <th scope="col" class="rankWidth">
                        Ranks
                      </th>
                      <th scope="col" class="hrWidth">
                        Image
                      </th>
                      <th scope="col" class="nameWidth">
                        Name
                      </th>
                      <th scope="col" class="resumeWidth">
                        Resume Forwarded
                      </th>
                      <th scope="col" class="pipWidth">
                        Pipeline
                      </th>
                      <th scope="col" class="turWidth">
                        Turned Up
                      </th>
                      <th scope="col" class="selWidth">
                        Revenue
                      </th>
                      <th scope="col" className="py-2 px-4 border-b">
                        Achievement Ratio
                        <Link
                          className="signOutLink"
                          to={{ pathname: "/" }}
                          onClick={handleSignOut}
                        >
                          <i class="fa-solid fa-right-from-bracket"></i>
                        </Link>
                      </th>
                      {!isSuperuser &&
                        userPermissions.includes("website.see_records") && (
                          <th className="col">Options</th>
                        )}
                    </tr>
                  </thead>

                  <tbody>
                    {/* {dailyEntryData && sortedData && */}
                    {sortedData &&
                      currentViewers.map((record, index) => {
                        // Calculate the actual index of the record in the entire dataset
                        const actualIndex = indexOfFirstRecord + index;

                        // Find the corresponding entry in pipelineandturnedup
                        const correspondingEntry = pipelineandturnedup.find(
                          (entry) => entry.user === record.user
                        );

                        const correspondingRecord = data.find(
                          (i) => i.id === record.user
                        );

                        // If a corresponding record is found, extract the image and name
                        const imageSrc = correspondingRecord
                          ? `${API_BASE_URL}${correspondingRecord.image}`
                          : "";
                        const userName = correspondingRecord
                          ? correspondingRecord.name
                          : "";

                        const targetRev = correspondingRecord
                          ? correspondingRecord.revenue
                          : "";
                        const target = correspondingRecord
                          ? correspondingRecord.target
                          : "";

                        // If corresponding entry is found, extract the values
                        const pipeline = correspondingEntry
                          ? correspondingEntry.pipline
                          : "";
                        const turnedUp = correspondingEntry
                          ? correspondingEntry.turned_up
                          : "";

                        // Calculate percentage based on display mode
                        const percentage = targetRev > 0 ? (record.revenue / targetRev) * 100 : 0;

                        return (
                          <>
                            <tr
                              key={actualIndex}
                              className={`${percentage >= 100
                                ? index === focusedIndex
                                  ? "bg-blue-200 text-black"
                                  : "text-blue-600"
                                : percentage >= 95
                                  ? index === focusedIndex
                                    ? "bg-green-200 text-black"
                                    : "text-green-500"
                                  : percentage >= 85
                                    ? index === focusedIndex
                                      ? "bg-yellow-200 text-black"
                                      : "text-yellow-500"
                                    : index === focusedIndex
                                      ? "bg-red-400 text-black"
                                      : "text-red-500"
                                }`}
                              style={{
                                height: "10vh!important",
                                position: "relative",
                              }}
                            >
                              {/* Award Ranking */}
                              <td
                                style={{ textAlign: "center" }}
                                className="py-2 px-4 border-b text-center"
                              >
                                <div className="awards">
                                  <span
                                    className={`${index === focusedIndex
                                      ? "text-4xl font-bold  recordRanking award-content"
                                      : "text-xl recordRanking award-content"
                                      }`}
                                  >
                                    {globalRecordCount + index + 1}
                                  </span>
                                  <span className="image-content"></span>
                                </div>
                              </td>
                              {/* Image */}
                              <td className="py-2 px-4 border-b text-center">
                                {/* Display the image if available */}
                                {imageSrc && (
                                  <img
                                    src={imageSrc}
                                    className="w-auto"
                                    style={{ height: "100px" }}
                                    alt=""
                                  />
                                )}
                              </td>
                              <td className="py-2 px-4 border-b text-center">
                                {/* Display the user name if available */}
                                {userName && <span>{userName}</span>}
                                <br />
                              </td>
                              {/* Resume forwarded */}
                              <td className="py-2 px-4 border-b text-center">
                                {record.resume_forwarded}
                              </td>
                              {/* Pipeline */}
                              <td className="py-2 px-4 border-b text-center">
                                {pipeline}
                              </td>
                              {/* Turned Up */}
                              <td className="py-2 px-4 border-b text-center">
                                {record.turned_up}
                              </td>
                              {/* Selected */}
                              <td className="py-2 px-4 border-b text-center">
                                {record.revenue}
                              </td>

                              <td className="py-2 px-4 border-b text-center">
                                {/* Calculate percentage here */}
                                <span
                                  className={`${percentage >= 100
                                    ? "text-blue-600"
                                    : percentage >= 95
                                      ? "text-green-500"
                                      : percentage >= 85
                                        ? "text-yellow-500"
                                        : "text-red-500"
                                    }`}
                                  style={{ fontSize: "1.2rem" }}
                                >
                                  {percentage.toFixed(2)}%
                                </span>
                              </td>
                              {/* Edit Button */}
                              {!isSuperuser &&
                                userPermissions.includes(
                                  "website.see_records"
                                ) && (
                                  <td className="py-2 px-4 border-b text-center">
                                    <button className="btn btn-primary">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-pencil"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                      </svg>
                                    </button>
                                  </td>
                                )}
                            </tr>
                          </>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <Announcementslider />
      </section>
    </>
  );
}
export default Viewers;
